/* Routine Builder: filter steps by hair need, total price, add all steps. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_routine_builder']) return;
  window.__hwsLoaded['component_routine_builder'] = true;

  var strings = window.hwsStrings || {};
  var config = window.hwsSettings || {};

  class HwsRoutineBuilder extends HTMLElement {
    connectedCallback() {
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-routine-step]'));
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-routine-concern]'));
      this.live = this.querySelector('[data-routine-live]');
      this.concern = this.dataset.defaultConcern || '';
      var self = this;
      this.chips.forEach(function (chip) {
        chip.addEventListener('click', function () { self.select(chip.getAttribute('data-routine-concern')); });
      });
      this.addEventListener('click', this.onClick.bind(this));
      this.select(this.concern, true);
      this.buildStepper();
      /* Producten van de andere haarbehoeften na het laden in rust ophalen, zodat een tabwissel
         meteen klaar is (zie laadStap). */
      var laadAlles = function () {
        self.querySelectorAll('[data-routine-laden]').forEach(function (ph) { self.laadStap(ph); });
      };
      var rust = function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(laadAlles, { timeout: 5000 });
        else setTimeout(laadAlles, 2000);
      };
      if (document.readyState === 'complete') rust();
      else window.addEventListener('load', rust, { once: true });
    }

    /* Een stap van een niet-gekozen haarbehoefte heeft alleen een lege plek met het product
       (data-routine-laden). Het productdeel komt uit sections/routine-product.liquid. Mislukt
       het, dan blijft de plek staan en probeert de volgende tabwissel het opnieuw. */
    laadStap(ph) {
      if (ph.__laden) return ph.__laden;
      var handle = ph.getAttribute('data-routine-laden');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      ph.__laden = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=routine-product', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var bron = doc.querySelector('.shopify-section') || doc.body;
          if (!bron.querySelector('.routine__product')) throw new Error('leeg');
          var knop = ph.getAttribute('data-knop');
          var add = bron.querySelector('[data-routine-add]');
          if (knop && add) add.textContent = knop;
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(bron.childNodes).forEach(function (n) { frag.appendChild(document.importNode(n, true)); });
          if (ph.parentNode) ph.parentNode.replaceChild(frag, ph);
        })
        .catch(function () { ph.__laden = null; });
      return ph.__laden;
    }

    laadZichtbaar() {
      var self = this;
      var wacht = [];
      this.visibleSteps().forEach(function (step) {
        var ph = step.querySelector('[data-routine-laden]');
        if (ph) wacht.push(self.laadStap(ph));
      });
      if (wacht.length) Promise.all(wacht).then(function () { self.updateTotal(); });
    }

    select(concern, silent) {
      this.concern = concern || '';
      var self = this;
      this.chips.forEach(function (chip) {
        var active = chip.getAttribute('data-routine-concern') === self.concern;
        chip.classList.toggle('hws-chip--active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.steps.forEach(function (step) {
        var stepConcern = step.getAttribute('data-concern') || '';
        step.hidden = !!(self.concern && stepConcern && stepConcern !== self.concern);
      });
      this.updateTotal();
      this.buildStepper();
      this.laadZichtbaar();
      if (!silent && this.live && this.concern) this.live.textContent = this.concern;
    }

    visibleSteps() {
      return this.steps.filter(function (step) { return !step.hidden; });
    }

    updateTotal() {
      var total = 0;
      var count = 0;
      this.visibleSteps().forEach(function (step) {
        var button = step.querySelector('[data-routine-add]');
        if (!button) return;
        total += parseInt(button.getAttribute('data-routine-price'), 10) || 0;
        count++;
      });
      var totalEl = this.querySelector('[data-routine-total]');
      if (totalEl) totalEl.textContent = count ? window.hwsFormatMoney(total) : '';
      var summary = this.querySelector('[data-routine-summary]');
      if (summary && count) {
        summary.textContent = (strings.routineTotal || '') + ' ' + (this.concern || '') + ' · ' + count;
      }
      var addAll = this.querySelector('[data-routine-add-all]');
      if (addAll) addAll.disabled = count === 0;
    }

    buildStepper() {
      var host = this.querySelector('[data-routine-stepper]');
      if (!host) return;
      host.innerHTML = '';
      var visible = this.visibleSteps();
      if (visible.length < 2) return;
      var self = this;
      visible.forEach(function (step, i) {
        var button = document.createElement('button');
        button.type = 'button';
        var numberEl = step.querySelector('.routine__step-number');
        var nameEl = step.querySelector('.routine__step-name');
        button.innerHTML =
          '<span class="routine__dot">' + (numberEl ? numberEl.textContent.trim() : i + 1) + '</span>' +
          '<span>' + (nameEl ? nameEl.textContent.trim() : '') + '</span>';
        button.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        button.addEventListener('click', function () {
          /* De aangetikte stap opent (of sluit weer). De andere stappen laten we
             staan zoals ze staan: wie twee stappen open wil hebben om te
             vergelijken, moet dat kunnen. */
          var stap = visible[i];
          var openen = stap.classList.contains('is-collapsed');
          stap.classList.toggle('is-collapsed', !openen);
          host.querySelectorAll('button').forEach(function (b, n) {
            b.setAttribute('aria-current', visible[n] && !visible[n].classList.contains('is-collapsed') ? 'true' : 'false');
          });
        });
        host.appendChild(button);
        step.classList.toggle('is-collapsed', i !== 0);
      });
    }

    onClick(event) {
      /* Op telefoon staat alleen de gekozen stap open. Klikken op een dichte
         stap moest ook werken: de stepper-knoppen erboven waren de enige manier
         om te wisselen, en dat is niet wat je verwacht als je op "Verzorgen"
         tikt. */
      /* De kop van een open stap dichtklappen. Alleen op de kop, zodat een klik op
         het product of de knop eronder gewoon blijft doen wat hij deed. */
      var kop = event.target.closest('.routine__step-head');
      if (kop && !event.target.closest('a,button')) {
        var stapOpen = kop.closest('.routine__step');
        if (stapOpen && !stapOpen.classList.contains('is-collapsed') && window.matchMedia('(max-width: 749px)').matches) {
          stapOpen.classList.add('is-collapsed');
          var stepperHost = this.querySelector('[data-routine-stepper]');
          var zichtbaar = this.visibleSteps();
          if (stepperHost) {
            stepperHost.querySelectorAll('button').forEach(function (b, n) {
              b.setAttribute('aria-current', zichtbaar[n] && !zichtbaar[n].classList.contains('is-collapsed') ? 'true' : 'false');
            });
          }
          return;
        }
      }

      var head = event.target.closest('.routine__step');
      if (head && head.classList.contains('is-collapsed') && !event.target.closest('a,button')) {
        var visible = this.visibleSteps();
        var index = visible.indexOf(head);
        if (index !== -1) {
          /* Alleen deze stap openklappen; wat al open stond blijft open. */
          head.classList.remove('is-collapsed');
          var host = this.querySelector('[data-routine-stepper]');
          if (host) {
            host.querySelectorAll('button').forEach(function (b, n) {
              b.setAttribute('aria-current', visible[n] && !visible[n].classList.contains('is-collapsed') ? 'true' : 'false');
            });
          }
          return;
        }
      }

      var one = event.target.closest('[data-routine-add]');
      if (one) {
        event.preventDefault();
        this.add([{ id: Number(one.getAttribute('data-routine-add')), quantity: 1 }], one);
        return;
      }
      var all = event.target.closest('[data-routine-add-all]');
      if (all) {
        event.preventDefault();
        var items = [];
        this.visibleSteps().forEach(function (step) {
          var button = step.querySelector('[data-routine-add]');
          if (button) items.push({ id: Number(button.getAttribute('data-routine-add')), quantity: 1 });
        });
        if (items.length) this.add(items, all);
      }
    }

    add(items, button) {
      button.classList.add('btn--loading');
      window.hwsCart.add(items).then(function (data) {
        if (data.__error || data.status) {
          if (window.hwsToast) window.hwsToast.show(data.description || strings.cartError);
          return;
        }
        window.hwsCart.renderSections(data);
        window.hwsCart.fetchState().then(function (s) { window.hwsCart.syncCount(s); });
        if (config.cartType === 'drawer' && document.getElementById('CartDrawer')) {
          window.hwsOverlay.open('CartDrawer');
        } else if (window.hwsToast) {
          window.hwsToast.show(strings.addedToCart);
        }
      }).finally(function () { button.classList.remove('btn--loading'); });
    }
  }
  if (!customElements.get('hws-routine-builder')) customElements.define('hws-routine-builder', HwsRoutineBuilder);
})();
